import { useTheme } from 'next-themes';

import { ColorMode } from '../../types/ColorMode';

export function useColorMode() {
  const { resolvedTheme, setTheme, forcedTheme } = useTheme();
  const colorMode = forcedTheme || resolvedTheme;
  const toggleColorMode = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };
  return {
    colorMode: colorMode as ColorMode,
    setColorMode: setTheme as (colorMode: ColorMode) => void,
    toggleColorMode,
  };
}
